'use client';

import { useGetJobDetail } from '@/features/jobs/api/jobs.queries';

type UseJobInsightJobMetricsParams = {
  jobDetailKey: string | number;
  jobTime?: number | string;
};

/** Insight «-наас хойш» шошны job detail `time`-ийг prop эсвэл detail fetch-ээр авна. */
export function useJobInsightJobMetrics({
  jobDetailKey,
  jobTime: jobTimeProp,
}: UseJobInsightJobMetricsParams) {
  const shouldFetchDetail = jobTimeProp === undefined;
  const { data: jobDetail, isLoading: isJobDetailLoading } = useGetJobDetail(
    jobDetailKey,
    { enabled: shouldFetchDetail && !!jobDetailKey, countView: false }
  );

  return {
    jobTime: jobTimeProp ?? jobDetail?.time,
    isJobDetailLoading: shouldFetchDetail && isJobDetailLoading,
  };
}
